import { section } from "@/neon";

import scrollIntoView from "@/lib/scrollIntoView";

section("rich-text", {
  onLoad() {
    this.scrollAnimation = scrollIntoView(this.container);
  },
  onUnload() {
    this.scrollAnimation.unload();
  },
});
